/**
 * Variant radios for product cards (show_variants tag).
 * Finds the form inside the closest product-form and updates variant id + button state.
 */
class VariantRadiosCard extends HTMLElement {
  constructor() {
    super();
    this.productForm = this.closest('product-form');
    this.form = this.productForm?.querySelector('[data-type="add-to-cart-form"]');
    if (!this.form) return;
    this.variantData = null;
    this.addButtons = this.productForm?.querySelectorAll('[type="submit"][name="add"]') || [];
    this.addEventListener('change', this.onVariantChange.bind(this));
    this.onVariantChange();
  }

  getVariantData() {
    if (!this.variantData) {
      const json = this.querySelector('script[type="application/json"]');
      if (json) this.variantData = JSON.parse(json.textContent);
    }
    return this.variantData || [];
  }

  getSelectedOptions() {
    const fieldsets = this.querySelectorAll('fieldset');
    return Array.from(fieldsets).map((fs) => {
      const checked = fs.querySelector('input:checked');
      return checked ? checked.value : null;
    });
  }

  findVariant(options) {
    const variants = this.getVariantData();
    return variants.find((v) => {
      return v.options && v.options.length === options.length && v.options.every((opt, i) => opt === options[i]);
    }) || null;
  }

  onVariantChange() {
    const options = this.getSelectedOptions();
    const variant = this.findVariant(options);
    const idInput = this.form.querySelector('input[name="id"]');
    if (idInput && variant) {
      idInput.value = variant.id;
      idInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    this.updateButtonState(variant);
    this.updatePrice(variant);
  }

  updatePrice(variant) {
    if (!variant) return;
    const card = this.closest('product-card') || this.closest('.product-card');
    if (!card) return;
    const priceWrapper = card.querySelector('.product-card__price-variant-wrapper');
    if (!priceWrapper) return;
    const moneyFormat = priceWrapper.getAttribute('data-money-format') || '{{amount}}';
    const formatPrice = (cents) => {
      if (typeof window.formatMoney === 'function') {
        return window.formatMoney(cents, moneyFormat, true);
      }
      const value = (cents / 100).toFixed(2);
      return moneyFormat.replace(/\{\{\s*(\w+)\s*\}\}/, value);
    };
    const formatted = formatPrice(variant.price);
    const priceEls = priceWrapper.querySelectorAll('[data-final-price]');
    priceEls.forEach((el) => { el.textContent = formatted; });
    const compareAtEls = priceWrapper.querySelectorAll('.price-item--regular s');
    if (variant.compare_at_price != null && variant.compare_at_price > variant.price && compareAtEls.length) {
      compareAtEls.forEach((el) => { el.textContent = formatPrice(variant.compare_at_price); });
    }
  }

  updateButtonState(variant) {
    this.addButtons.forEach((btn) => {
      const textSpan = btn.querySelector('.product-form__submit-text');
      if (variant) {
        btn.disabled = !variant.available;
        if (textSpan) {
          textSpan.textContent = variant.available
            ? (window.variantStrings && window.variantStrings.addToCart) || 'Add to cart'
            : (window.variantStrings && window.variantStrings.soldOut) || 'Sold out';
        }
      }
    });
  }
}

customElements.define('variant-radios-card', VariantRadiosCard);
